import clsx from "clsx";
import React from "react";

export default function Container({children, className}) {
   return (
      <div className={clsx("max-w-6xl h-full px-0 xl:px-0 m-auto", className)}>
         {children}
      </div>
   );
}
